export const EMPTY_ORDER_ITEM = {
  order_id: '',
  value: '',
  quantity: 1,
  salable_id: '',
  salable_type: 'Product',
  discount_value: 0.0,
}
